'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.fixNestedModelValidation = fixNestedModelValidation;

var _nestedtypes = require('nestedtypes');

var _nestedtypes2 = _interopRequireDefault(_nestedtypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Everything in this file is copy - paste from nestedreact lib, except Model.prototype.getLink method.
 * Model.prototype.getLink overriden cause disabling links cache fixes validation of nested models
 */
function fixNestedModelValidation() {
    function ModelLink(model, attr, value) {
        _nestedtypes2.default.Link.call(this, value);
        this.model = model;
        this.attr = attr;
    }

    ModelLink.prototype = Object.create(_nestedtypes2.default.Link.prototype, {
        constructor: { value: ModelLink },
        set: {
            value: function value(x) {
                this.model[this.attr] = x;
            }
        },

        error: {
            get: function get() {
                if (this._error === void 0) {
                    this._error = this.model.getValidationError(this.attr);
                }

                return this._error;
            },

            set: function set(x) {
                this._error = x;
            }
        }
    });

    _nestedtypes2.default.Model.prototype.getLink = function getLink(key) {
        return new ModelLink(this, key, this[key]);
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/nestedModelValidationFix.js
// module id = 1414
// module chunks = 118